import React, { useEffect, useState } from 'react';
import DATA from './constant';
import { KoDP, KoKanban, KoTabs, KoText, KoTitle } from 'packages';
import styles from './mytask.module.scss';
export default function MyTask() {
  const [tickets, setTickets] = useState(DATA);
  const [, setCurrentRecord] = useState();

  const workspaceId='woscd98fbb2df';


  useEffect(() => {
    getTickets();
  }, []);
  const onCardClick = (row, source) => {
    let rowObject = {...row, workspaceId: workspaceId};
    setCurrentRecord(rowObject);
   
  };


  const onCellClick=(row)=>{
    setCurrentRecord(row);
  };



  const ModifyTheLabel = async(status) => {
    return status;
  };

  
  const UpdateStatus =async(newStatus) => {
    const {cardId, columnHeader, currentCardData} = newStatus;
    const newStatusValue = await ModifyTheLabel(columnHeader);
    if(!newStatusValue) return;

    const updatedValues = {
      ...currentCardData,
      status: newStatusValue
    };

    console.log(updatedValues, cardId);

  };

  const getCards = (tickets, wos) => {
    var mapped =tickets?.map(item => ({ 'id': item.ticketId, 'summary': item.summary, 'status': item.status, ...item}) );
    const groups =mapped.reduce((groups, item) => {
      const group = (groups[item.status] || []);
      group.push(item);
      groups[item.status] = group;
      return groups;
    }, {});
    const initializeBoard =[
      {
        "workflowId": "",
        "name": "Todo",
        "label": "Todo",
        "value": 1,
        "background": "rgba(145, 158, 171, 0.16)",
        "color": "#637381",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          },
          {
            "transitionId": "",
            "name": "On Hold",
            "label": "On Hold",
            "value": 6,
            "background": "rgba(255, 204, 128, 0.16)",
            "color": "#ff8f00"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "In Progress",
        "label": "In Progress",
        "value": 2,
        "background": "rgba(255, 239, 179, 0.16)",
        "color": "#f57f17",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "Blocked",
            "label": "Blocked",
            "value": 3,
            "background": "rgba(255, 171, 145, 0.16)",
            "color": "#c62828"
          },
          {
            "transitionId": "",
            "name": "Ready For QA",
            "label": "Ready For QA",
            "value": 4,
            "background": "rgba(144, 202, 249, 0.16)",
            "color": "#0d47a1"
          },
          {
            "transitionId": "",
            "name": "On Hold",
            "label": "On Hold",
            "value": 6,
            "background": "rgba(255, 204, 128, 0.16)",
            "color": "#ff8f00"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Blocked",
        "label": "Blocked",
        "value": 3,
        "background": "rgba(255, 171, 145, 0.16)",
        "color": "#c62828",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          },
          {
            "transitionId": "",
            "name": "On Hold",
            "label": "On Hold",
            "value": 6,
            "background": "rgba(255, 204, 128, 0.16)",
            "color": "#ff8f00"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Ready For QA",
        "label": "Ready For QA",
        "value": 4,
        "background": "rgba(144, 202, 249, 0.16)",
        "color": "#0d47a1",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Review",
            "label": "In Review",
            "value": 5,
            "background": "rgba(209, 164, 224, 0.16)",
            "color": "#6a1b9a"
          },
          {
            "transitionId": "",
            "name": "QA Failed",
            "label": "QA Failed",
            "value": 7,
            "background": "rgba(255, 171, 145, 0.16)",
            "color": "#c62828"
          },
          {
            "transitionId": "",
            "name": "Done",
            "label": "Done",
            "value": 15,
            "background": "rgba(165, 214, 167, 0.16)",
            "color": "#388e3c"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "In Review",
        "label": "In Review",
        "value": 5,
        "background": "rgba(209, 164, 224, 0.16)",
        "color": "#6a1b9a",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "Review Complete",
            "label": "Review Complete",
            "value": 13,
            "background": "rgba(165, 214, 167, 0.16)",
            "color": "#388e3c"
          },
          {
            "transitionId": "",
            "name": "QA Failed",
            "label": "QA Failed",
            "value": 7,
            "background": "rgba(255, 171, 145, 0.16)",
            "color": "#c62828"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "On Hold",
        "label": "On Hold",
        "value": 6,
        "background": "rgba(255, 204, 128, 0.16)",
        "color": "#ff8f00",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          },
          {
            "transitionId": "",
            "name": "Deferred",
            "label": "Deferred",
            "value": 9,
            "background": "rgba(176, 190, 195, 0.16)",
            "color": "#37474f"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "QA Failed",
        "label": "QA Failed",
        "value": 7,
        "background": "rgba(255, 171, 145, 0.16)",
        "color": "#c62828",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          },
          {
            "transitionId": "",
            "name": "Abandoned",
            "label": "Abandoned",
            "value": 8,
            "background": "rgba(244, 143, 177, 0.16)",
            "color": "#d81b60"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Abandoned",
        "label": "Abandoned",
        "value": 8,
        "background": "rgba(244, 143, 177, 0.16)",
        "color": "#d81b60",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "",
            "label": "Reopen",
            "value": 11,
            "background": "",
            "color": ""
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Deferred",
        "label": "Deferred",
        "value": 9,
        "background": "rgba(176, 190, 195, 0.16)",
        "color": "#37474f",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "Todo",
            "label": "Todo",
            "value": 1,
            "background": "rgba(145, 158, 171, 0.16)",
            "color": "#637381"
          },
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Po Review",
        "label": "Po Review",
        "value": 10,
        "background": "rgba(144, 202, 249, 0.16)",
        "color": "#0d47a1",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "Reopen",
            "label": "Reopen",
            "value": 11,
            "background": "rgba(145, 158, 171, 0.16)",
            "color": "#637381"
          },
          {
            "transitionId": "",
            "name": "Done",
            "label": "Done",
            "value": 15,
            "background": "rgba(165, 214, 167, 0.16)",
            "color": "#388e3c"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Reopen",
        "label": "Reopen",
        "value": 11,
        "background": "rgba(145, 158, 171, 0.16)",
        "color": "#637381",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "Todo",
            "label": "Todo",
            "value": 1,
            "background": "rgba(145, 158, 171, 0.16)",
            "color": "#637381"
          },
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Duplicate",
        "label": "Duplicate",
        "value": 12,
        "background": "rgba(244, 143, 177, 0.16)",
        "color": "#d81b60",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "",
            "label": "Reopen",
            "value": 11,
            "background": "",
            "color": ""
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Review Complete",
        "label": "Review Complete",
        "value": 13,
        "background": "rgba(165, 214, 167, 0.16)",
        "color": "#388e3c",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Progress",
            "label": "In Progress",
            "value": 2,
            "background": "rgba(255, 239, 179, 0.16)",
            "color": "#f57f17"
          },
          {
            "transitionId": "",
            "name": "Done",
            "label": "Done",
            "value": 15,
            "background": "rgba(165, 214, 167, 0.16)",
            "color": "#388e3c"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Code Review",
        "label": "Code Review",
        "value": 14,
        "background": "rgba(209, 164, 224, 0.16)",
        "color": "#6a1b9a",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "In Review",
            "label": "In Review",
            "value": 5,
            "background": "rgba(209, 164, 224, 0.16)",
            "color": "#6a1b9a"
          },
          {
            "transitionId": "",
            "name": "Review Complete",
            "label": "Review Complete",
            "value": 13,
            "background": "rgba(165, 214, 167, 0.16)",
            "color": "#388e3c"
          }
        ]
      },
      {
        "workflowId": "",
        "name": "Done",
        "label": "Done",
        "value": 15,
        "background": "rgba(165, 214, 167, 0.16)",
        "color": "#388e3c",
        "nextStatuses": [
          {
            "transitionId": "",
            "name": "",
            "label": "Reopen",
            "value": 11,
            "background": "",
            "color": ""
          }
        ]
      }
    ]?.filter(status => status.label && status.label.trim() !== "")
      .map(status => ({
        id: status.value,
        label: status.label,
        background: status.background,
        color: status.color,
        cards: []
      }));
        
    const populateBoardWithTickets = (tickets) => {
      const board = { columns: initializeBoard };
      if (!tickets) return board;
      Object.entries(tickets).forEach(([status, cards]) => {
        const column = board.columns.find(col =>
          col.id === parseInt(status)
        );
        if (column) {
          column.cards = cards;
        }
      });
          
      return board;
    };
    const populatedBoard = populateBoardWithTickets(groups);
    return populatedBoard;
  };
  const getTickets=(wos)=>{
    setTickets();
    let tickets = [];
    for (let index = 0; index < DATA?.length; index++) {
      const element = DATA[index];
      const cards = getCards(element?.tickets ? element?.tickets : [], wos);
      tickets.push({
        key: element?.assignee,
        label: <div className={styles.assignee}>
          {element?.['logo']?  <KoDP className={styles.dp} width={24} height={24} shape={'default'} logo={element?.['logo']} /> :
            <div className={`${styles.circle}  ${element ?
              element?.assigneeName?.charAt(0).toLowerCase() : 'a'}`}>
              <KoText className={`${styles.letter} fs-size-11`} text={element?.assigneeName?.charAt(0)} />
            </div>}
          <div className={styles.info}>
            <KoText className={styles.text} ellipsis={true} text={`${element?.assigneeName}`} />
            <KoText className={styles.textTicket} ellipsis={true} text={`${element?.totalCount} Tickets`} />
          </div>
        </div>,
        children:cards ? <KoKanban
          initialBoard={cards}
          onCardDragEnd={UpdateStatus}
          onNewCardConfirm={draftCard => ({
            id: new Date().getTime(),
            ...draftCard
          })}
          onCardClick={onCardClick}
          onCellClick={onCellClick}
          workflow={wos?.template?.activityTypes}
          onCardNew={()=>{}}
        /> : <></>
      });
    }
    setTickets(tickets);
  };
  
  return (
    <div className={`${styles.wrapper} profileSection`}>
      <KoTitle text="My Tasks" level={3} className={styles.title} />
      <KoTabs  options={tickets} defaultActiveKey={['1']}  />
    </div>
  );
}
